"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PettyCashApiError = exports.KINDS_WITH_DOCUMENT = void 0;
exports.wroteAnything = wroteAnything;
exports.submitEntry = submitEntry;
exports.analyzeDocument = analyzeDocument;
exports.fetchSheetLinks = fetchSheetLinks;
const MainSetupReact_1 = __importDefault(require("../../React/MainSetupReact"));
/**
 * Rodzaje z kwotą netto, brutto i numerem dokumentu. Formularz, walidacja i podgląd
 * wiersza pytają o to samo, więc lista stoi w jednym miejscu. Backend ma tę regułę
 * u siebie, na modelu domenowym - to jest jej odbicie po stronie ekranu.
 */
exports.KINDS_WITH_DOCUMENT = [
    "POSTAL",
    "INVOICE",
    "RECEIPT",
    "FUEL",
];
/**
 * Czy cokolwiek naprawdę trafiło do arkusza.
 *
 * Backend odpowiada 201 także wtedy, gdy pominął zapis, bo ten sam wpis już tam jest —
 * z punktu widzenia HTTP nic się nie stało złego. Dla człowieka to jednak różnica między
 * „dodane" a „nie dodane", i to ona decyduje o kolorze komunikatu.
 */
function wroteAnything(result) {
    return result.cash.action === "write" || result.register?.action === "write";
}
class PettyCashApiError extends Error {
    constructor(message, status, errors = []) {
        super(message);
        this.name = "PettyCashApiError";
        this.status = status;
        this.errors = errors;
    }
}
exports.PettyCashApiError = PettyCashApiError;
async function parseError(response, fallback) {
    let payload;
    try {
        payload = await response.json();
    }
    catch {
        payload = undefined;
    }
    throw new PettyCashApiError(payload?.error || `${fallback} (${response.status})`, response.status, Array.isArray(payload?.errors) ? payload.errors : []);
}
async function submitEntry(payload) {
    const response = await fetch(`${MainSetupReact_1.default.serverUrl}pettyCash/entries`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });
    if (!response.ok)
        await parseError(response, "Nie udało się zapisać wpisu");
    return (await response.json());
}
/**
 * Zdjęcie albo PDF paragonu/faktury → podpowiedzi kwot i numeru.
 *
 * Serwer odczytuje tekst i pyta model; obraz nie opuszcza backendu. Nagłówka
 * `Content-Type` nie ustawiamy — przy `FormData` przeglądarka musi dopisać własną
 * granicę multipart, a ręczne ustawienie ją psuje.
 */
async function analyzeDocument(file) {
    const body = new FormData();
    body.append("file", file);
    const response = await fetch(`${MainSetupReact_1.default.serverUrl}pettyCash/documents/analyze`, {
        method: "POST",
        credentials: "include",
        body,
    });
    if (!response.ok)
        await parseError(response, "Nie udało się przeanalizować dokumentu");
    return (await response.json());
}
/** Adresy obu arkuszy — pochodzą z konfiguracji serwera, więc w dev prowadzą do kopii. */
async function fetchSheetLinks() {
    const response = await fetch(`${MainSetupReact_1.default.serverUrl}pettyCash/links`, {
        credentials: "include",
    });
    if (!response.ok)
        await parseError(response, "Nie udało się pobrać adresów arkuszy");
    return await response.json();
}
